import { styled } from 'styled-components';
import { SDiv } from '~/components/game/rules-solo-content';
import { SPText } from '~/components/styles/styles';

type IProps = {};

type TProps = IProps;

export function RulesBattleContent({}: TProps) {
  return (
    <Container>
      <SPText>{`Dans le mode Battle, affrontez d'autres joueurs en répondant à des questions pour prouver votre expertise ferroviaire.`}</SPText>
      <SDiv>
        <SPText $textDecoration="underline">Déroulement du défi</SPText>
        <SPText>- Chaque bonne réponse rapporte une couronne.</SPText>
        <SPText>
          - Lorsqu'un joueur accumule trois couronnes, celles-ci sont converties
          en un badge.
        </SPText>
        <SPText>
          - Le joueur ayant lancé le défi peut gagner jusqu'à 2 badges avant que
          le tour passe à son adversaire.
        </SPText>
        <SPText>
          - Par la suite, un joueur conserve la main tant qu'il répond
          correctement. Une mauvaise réponse entraîne le passage du tour.
        </SPText>
      </SDiv>

      <SDiv>
        <SPText $textDecoration="underline">Temps de réponse</SPText>
        <SPText>
          - Chaque joueur dispose de 5 jours maximum pour jouer son tour.
        </SPText>
        <SPText>
          - Si un joueur ne joue pas dans ce délai, le défi est considéré comme
          perdu.
        </SPText>
      </SDiv>

      <SDiv>
        <SPText $textDecoration="underline">Conditions de victoire</SPText>
        <SPText>
          - Le premier joueur à obtenir 5 badges remporte le défi.
        </SPText>
        <SPText>
          - Une notification de défaite est envoyée au joueur perdant.
        </SPText>
        <SPText>
          - Une notification de victoire est envoyée au joueur gagnant.
        </SPText>
      </SDiv>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
